module.exports = __webpack_public_path__ + "img/logo-vertical-full-white.7a94985e.png";